module.exports = __webpack_public_path__ + "img/product-strengthen-img.b13a29fb.svg";